"use client";

import { type FC, startTransition, useEffect } from "react";
import { useRouter } from "next/navigation";
import posthog from "posthog-js";

import { PrimaryButton } from "~/client/components/buttons/PrimaryButton";
import { emailGlobalErrorNotice } from "~/client/services/functions/email";
import type { ErrorPageProps } from "~/types";
import { ErrorRegistry } from "~/shared/errors/registry";

const RSC_GENERIC_MESSAGE = "An error occurred in the Server Components render";

const AuthErrorPage: FC<ErrorPageProps> = ({ error, reset }) => {
	const router = useRouter();

	const handleReset = () => {
		startTransition(() => {
			router.refresh();
			reset();
		});
	};

	useEffect(() => {
		posthog.captureException(error, {
			Cause: error.cause,
			Digest: error.digest,
			Message: error.message,
			Name: error.name,
			"Stack Trace": error.stack,
		});

		// Resolve the promise because errors are returned rather than thrown in Server Functions
		emailGlobalErrorNotice(error).then(error => error && console.error(error));
	}, [error]);

	return (
		<div className="auth">
			<div className="auth__content-container">
				<div>
					<h1>Error - something went wrong!</h1>
					<p>
						{error.message.includes(RSC_GENERIC_MESSAGE) && "code" in error
							? ErrorRegistry[error.code as keyof typeof ErrorRegistry].message
							: "An unexpected error occurred. Please try again."}
					</p>
				</div>
				<div
					style={{
						alignItems: "center",
						display: "flex",
					}}
				>
					<PrimaryButton onClick={handleReset}>Try again</PrimaryButton>
				</div>
			</div>
		</div>
	);
};

export default AuthErrorPage;
